import { Tab as MuiTab, TabProps as MuiTabProps } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';

export interface TabProps extends MuiTabProps {
  tabsId?: string;
}

export const Tab = styled(({ tabsId, ...props }: TabProps) => (
  <MuiTab sx={{ backgroundColor: 'common.white' }} {...props} {...(tabsId ? a11yProps(tabsId, props.value) : {})} />
))({});

function a11yProps(tabsId: string, value: string) {
  return {
    id: `${tabsId}-tab-${value}`,
    'aria-controls': `${tabsId}-tabpanel-${value}`,
  };
}
